var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscoverItemIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 29.9999C10.1061 30 10.2154 30 10.3282 30H20M10 29.9999C8.35288 29.9987 7.4889 29.978 6.81966 29.637C6.19245 29.3175 5.68289 28.8062 5.36331 28.179C5 27.466 5 26.5338 5 24.667V15.3337C5 13.4668 5 12.5327 5.36331 11.8197C5.68289 11.1925 6.19245 10.6829 6.81966 10.3633C7.5327 10 8.46682 10 10.3337 10H29.667C31.5338 10 32.466 10 33.179 10.3633C33.8062 10.6829 34.3175 11.1925 34.637 11.8197C35 12.532 35 13.465 35 15.3282V24.6718C35 26.535 35 27.4666 34.637 28.179C34.3175 28.8062 33.8062 29.3175 33.179 29.637C32.4667 30 31.535 30 29.6718 30H20M10 29.9999C10.0001 28.159 12.2386 26.6667 15 26.6667C17.7614 26.6667 20 28.1591 20 30M10 29.9999C10 29.9999 10 29.9999 10 29.9999ZM30 23.3333H23.3333M30 18.3333H25M15 21.6667C13.1591 21.6667 11.6667 20.1743 11.6667 18.3333C11.6667 16.4924 13.1591 15 15 15C16.8409 15 18.3333 16.4924 18.3333 18.3333C18.3333 20.1743 16.8409 21.6667 15 21.6667Z",
    stroke: "#191919",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverItemIcon6);
export default __webpack_public_path__ + "static/media/discoverItemIcon6.5d80e49891bdb7b44715ec70f2a1316a.svg";
export { ForwardRef as ReactComponent };